import React, { Component } from 'react';
import './index..css';

class Footer extends Component {
  render() {
    return (
      <footer>
        <h1 className="Footer-title">Taren Gorman</h1>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js